import type { AppRouteModule } from "/@/router/types";

import { LAYOUT } from "/@/router/constant";

const galleryRouter: AppRouteModule = {
  path: "/gallery",
  name: "Gallery",
  component: LAYOUT,
  redirect: "/gallery/index",
  meta: {
    hideChildrenInMenu: false,
    icon: "ant-design:home-outlined",
    title: "图库",
    orderNo: 2,
  },
  children: [
    {
      path: "index",
      name: "GalleryIndex",
      component: () => import("/@/views/gallery/index.vue"),
      meta: {
        title: "图库",
        hideMenu: false,
      },
    },
    {
      path: "ads",
      name: "GalleryADS",
      component: () => import("/@/views/gallery/ads.vue"),
      meta: {
        title: "广告管理",
        hideMenu: false,
      },
    },
  ],
};

export default galleryRouter;
